export enum EvAreaType {
    Undefined = 0,
    HousingCooperative = 3,
    PostcodeArea = 5,
    BasicUnit = 6,
    Municipality = 7,
    County = 8,
    SubCityDistrict = 9,
    SubCouncilGroup = 10,
    CityDistrict = 11,
    Street = 12,
}